import { render, staticRenderFns } from "./SoldoutGroup.vue?vue&type=template&id=6a35cd28&"
import script from "./SoldoutGroup.vue?vue&type=script&lang=ts&"
export * from "./SoldoutGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports